const STORAGE_KEY = 'qr_login_enabled';
const QUERY_PARAM = 'qrlogin';

/**
 * The QR sign-in entry point is hidden by default: the mobile application that scans the code
 * does not exist yet, so the button has nothing to offer a real dealer.
 *
 * Visiting `/login?qrlogin=1` turns it on for that browser (the flag is remembered), and
 * `/login?qrlogin=0` turns it back off. Nothing about the password form depends on this.
 */
export const isQrLoginEnabled = (): boolean => {
  try {
    const param = new URLSearchParams(window.location.search).get(QUERY_PARAM);

    if (param === '1') {
      localStorage.setItem(STORAGE_KEY, '1');
    }

    if (param === '0') {
      localStorage.removeItem(STORAGE_KEY);
    }

    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};
